import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import {
  addTagApi,
  updateTagApi,
  deleteTagApi,
  removeMultipleSelectedApiTags,
} from 'util/Api/tags';
import { getTags, getTag, addCandidateToTag as addCandidateToTagApi } from 'util/Api/user';

export const setCandidateAddedToTag = createAction('user/setCandidateAddedToTag');

export const fetchTags = createAsyncThunk(
  'tags/fetchTags',
  async ({ pageNumber, itemsPerPage, sort, filter }, { rejectWithValue }) => {
    try {
      return await getTags({ pageNumber, itemsPerPage, sort, filter });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const addTags = createAsyncThunk(
  'tags/addTags',
  async ({ tagName, isReports }, { rejectWithValue }) => {
    try {
      return await addTagApi({ tagName, isReports });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const updateTags = createAsyncThunk(
  'tags/updateTags',
  async ({ tagName, isReports, tagId, snackBarStatus }, { rejectWithValue }) => {
    try {
      return await updateTagApi({ tagName, isReports, tagId, snackBarStatus });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const deleteTag = createAsyncThunk(
  'tags/deleteTag',
  async ({ tagName }, { rejectWithValue }) => {
    try {
      return await deleteTagApi({ tagName });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchTag = createAsyncThunk(
  'tags/fetchTag',
  async ({ tagId }, { rejectWithValue }) => {
    try {
      return await getTag({ tagId });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const resetDeleteStatus = createAction('tags/resetDeleteStatus');
export const resetUpdateStatus = createAction('tags/resetUpdateStatus');

export const removeError = createAction('tags/removeError');
export const resetDeleteStatusCandidateTags = createAction(
  'thread/resetDeleteStatusCandidateCampaign',
);
export const removeMultiJobCandidatesTag = createAsyncThunk(
  'campaigns/removeMultiJobCandidatesTag',
  async ({ candidateIds, tagName, customerId }, { rejectWithValue }) => {
    try {
      return await removeMultipleSelectedApiTags({ candidateIds, tagName, customerId });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const addCandidateToTag = createAsyncThunk(
  'tags/addCandidateToTag',
  async ({ tagId, candidateId }, { rejectWithValue }) => {
    try {
      return await addCandidateToTagApi({ tagId, candidateId });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
